import { ReactNode, useEffect } from 'react';
import Header from '../Header';
import Footer from '../Footer';
import { Container as UIContainer } from '@jobtarget/ui-library';
import { useLayout } from '../../context/LayoutContext';
import { Outlet, useLocation } from 'react-router-dom';
import { initializeJobseekerHotjar } from '../../utils/hotjar';

// import '../css/Layout.module.css'


interface ILayout {
  children?: ReactNode;
  userType?: string,
}

const Layout = ({ children, userType="applicant" }: ILayout) => {
  const { 
    title, 
    icon,
    setIcon, 
    headerContent, 
    footerContent,
    setTitle
  } = useLayout();

  const location = useLocation();

  useEffect(() => {
    // Initialize Hotjar only for applicant (jobseeker) pages
    if (userType === 'applicant') {
      // console.log(`[Layout] Mounting applicant page: ${location.pathname}`);
      initializeJobseekerHotjar(location.pathname);
    }
  }, [userType, location.pathname]);

  useEffect(() => {
    // Only set default title if we're not in an expanded interview view
    const isExpandedView = location.pathname.includes('/recruiter/interview/');
    
    if (userType === 'recruiter' && !isExpandedView) {
      setIcon('/svgs/icon-container.svg');
      setTitle('Video Screener');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userType, location.pathname, setTitle]);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      // VI-717: only recruiter owns the full-viewport sticky-footer column here.
      // On applicant/legacy routes the height + sticky footer are owned by the outer
      // <JobseekerChrome> scaffold, so forcing 100vh here would push its footer below
      // the fold. Content centering (maxWidth) is kept.
      ...(userType === 'recruiter' ? { minHeight: '100vh' } : {}),
      position: 'relative',
      ...(userType === 'applicant' ? { maxWidth: '1408px', margin: '0 auto', width: '100%' } : {}),
    }}>
      <div style={{
        flex: '1 0 auto',
      }}>
        {userType === 'recruiter' && <Header />}
        <main className="main-content">
          <UIContainer className="full-height-container ">
            <UIContainer.Header
              icon={
                <img
                  src={icon}
                  alt="Logo"
                  width={32}
                  height={32}
                  style={{ objectFit: 'contain' }}
                />
              }
              title={title}
              
            >
              {headerContent}
            </UIContainer.Header>
            <UIContainer.Body>
              <Outlet />
              {children}
            </UIContainer.Body>
            <UIContainer.Footer>
              {footerContent}
            </UIContainer.Footer>
          </UIContainer>
        </main>
      </div>
      {userType === 'recruiter' && <Footer />}
    </div>
  );
};

export default Layout;